<div #element class="dlp-grid-status-dashboard">
  <div class="dlp-grid-status-dashboard__wrapper">
    <dlp-grid-status-dashboard-chart [chartData$]="chartDataSubject.asObservable()"></dlp-grid-status-dashboard-chart>
    <dlp-grid-status-dashboard-alarms [alarmData$]="alertDataSubject.asObservable()"></dlp-grid-status-dashboard-alarms>
    <dlp-grid-status-dashboard-grid-time></dlp-grid-status-dashboard-grid-time>
  </div>
</div>
